import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Typography from '../../../Pdf/components/Typography';
import Column from '../../../Pdf/components/Column';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';
import { PeriodEndReportPageProps } from '../../types';
import PeriodEndReportPage from './PeriodEndReportPage';
import Divider from './Divider';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    height: '200px',
    width: '250px',
  },
  copyContainer: {
    gap: theme.spacing(theme.spacingSizes.xxs * 1.5),
    padding: theme.spacing(0, theme.spacingSizes.xl),
  },
  title: {
    fontSize: '20px',
    lineHeight: '25px',
  },
});

type Props = PeriodEndReportPageProps & {
  partNumber: 1 | 2 | 3;
  title: string;
  subtitle: string;
};

const PartCoverPage: FC<Props> = ({
  partNumber,
  title,
  subtitle,
  firmLogoUrl,
  pageNumber,
  totalPages,
}) => {
  return (
    <PeriodEndReportPage
      backgroundColor={theme.palette.grey[100]}
      firmLogoUrl={firmLogoUrl}
      pageNumber={pageNumber}
      totalPages={totalPages}
    >
      <Column centered justify="center" style={styles.container}>
        <Row centered style={styles.contentContainer}>
          <Divider orientation="vertical" />
          <Column style={styles.copyContainer}>
            <Typography variant="h6" color={theme.palette.grey[600]}>
              Part {'I'.repeat(partNumber)}
            </Typography>
            <Typography variant="h5" style={styles.title}>
              {title}
            </Typography>
            <Typography variant="body2" color={theme.palette.grey[600]}>
              {subtitle}
            </Typography>
          </Column>
        </Row>
      </Column>
    </PeriodEndReportPage>
  );
};

export default PartCoverPage;
